import { fromJS } from 'immutable';
import { LoaderStatus } from '../common/components/CommonLoader';

const initialData = fromJS({
  items: [],
  totalItems: 0,
  loaderStatus: LoaderStatus.IN_PROGRESS,
});

export const SEARCH_INVOICES = 'SEARCH_INVOICES';
export const SEARCH_INVOICES_SUCCESS = 'SEARCH_INVOICES_SUCCESS';
export const SEARCH_INVOICES_FAILURE = 'SEARCH_INVOICES_FAILURE';

export default (state = initialData, { type, payload }) => {
  switch (type) {
    case SEARCH_INVOICES:
      return state.merge({
        loaderStatus: LoaderStatus.IN_PROGRESS,
      });
    case SEARCH_INVOICES_SUCCESS:
      return state.merge({
        items: payload.items,
        totalItems: payload.totalItems,
        loaderStatus: LoaderStatus.SUCCESS,
      });
    case SEARCH_INVOICES_FAILURE:
      return state.merge({
        loaderStatus: LoaderStatus.NOT_PENDING,
      });
    default:
      return state;
  }
};
